// /infra — Infrastructure & Costs for the instance's admins.
//
// Same panel the Dev Console shows under its Infra view, reachable without
// the internal claim: an org admin/owner reads the map, the costs and the
// catalog (GET /dev/ops/infra is requireOpsViewer). Refresh and planning
// stay internal-only — those controls open agent sessions on the repo.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import InfraPanel from '../components/infra/InfraPanel';
import { useInternalClaim } from './DevConsole';
import { useTenant, isPrivileged } from '../data/entities';

export default function Infra() {
  const internal = useInternalClaim();
  const t = useTenant();
  const navigate = useNavigate();
  const admin = internal || isPrivileged(t.role);
  if (!admin) {
    return (
      <div className="cs-page">
        <div className="cs-empty">Infrastructure &amp; Costs is for organization admins and owners{t.loaded ? '' : ' — loading your seat…'}.</div>
      </div>
    );
  }
  return (
    <div className="cs-page">
      <InfraPanel internal={internal} onOpenSession={internal ? () => navigate('/dev') : null} />
    </div>
  );
}
